import React from 'react';

import type { CamelCasedPropertiesDeep } from 'type-fest/index';
import type { ConvertWebApiDeclaredToActual } from '@zola-helpers/client/dist/es/@types/svc-web-api';

import type { WDateRange } from '@zola/svc-web-api-ts-client';

const DateOptions: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', timeZone: 'UTC' };

export const DateRange = ({
  dateRange = {},
  className,
}: {
  dateRange: ConvertWebApiDeclaredToActual<CamelCasedPropertiesDeep<WDateRange>>;
  className?: string;
}) => {
  let formattedDateRange;
  if (dateRange.max && dateRange.min) {
    if (dateRange?.max > dateRange.min) {
      // need to see how they get formatted
      const formattedMinDate = new Date(dateRange.min).toLocaleString('en-US', DateOptions);
      const formattedMaxDate = new Date(dateRange.max).toLocaleString('en-US', DateOptions);

      if (formattedMinDate === formattedMaxDate) {
        formattedDateRange = formattedMaxDate;
      } else {
        formattedDateRange = `${formattedMinDate} - ${formattedMaxDate}`;
      }
    } else {
      // the two dates were exactly equal or min was greater than max, just show the max
      formattedDateRange = new Date(dateRange.max).toLocaleString('en-US', DateOptions);
    }
  }

  return <span className={className}>{formattedDateRange}</span>;
};

export default DateRange;
